import React, { useEffect, useMemo, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import Buttonc from "../../../stories/common/button";
import styles from "./index.module.scss";
import DropdownC from "../../../stories/common/dropdown";
import MultiSelectC from "../../../stories/common/multi-select";
// import { InputSwitch } from "primereact/inputswitch";
import { Calendar } from "primereact/calendar";
import { useToast } from "../../../stories/common/toast/toast";
import { useAddCallRecords } from "../../../hooks/react-query/investor-dashboard/useAddCallRecords";
import { useEditCallRecords } from "../../../hooks/react-query/investor-dashboard/useEditCallRecords";
import moment from "moment";
import { useAddNotes } from "../../../hooks/react-query/investor-dashboard/useAddNotes";
import { useCounties } from "../../../hooks/react-query/calling-pipeline/useCounties";
interface AddCallDialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  accountId: string;
  propertyId: string;
  checkoutId: string;
  item?: any;
  isEdit?: boolean;
}

const notesRequiredStatuses = new Set([
  "do not contact",
  "blacklisted",
  "wholesaler"
]);

const callingStatusOptions = [
  { label: "Interested", value: "interested" },
  { label: "Not Interested", value: "not interested" },
  {
    label: "Further Information Requested",
    value: "further information requested"
  },
  {
    label: "Wrong Contact Information",
    value: "Wrong Contact Information"
  },
  { label: "Callback Requested", value: "callback requested" },
  { label: "Voicemail Left", value: "voice mail left" },
  { label: "No Answer", value: "no answer" },
  { label: "Unavailable", value: "unavailable" },
  { label: "No Longer Investing", value: "no longer investing" },
  { label: "Do Not Contact", value: "do not contact" },
  { label: "Blacklisted", value: "blacklisted" },
  { label: "Wholesaler", value: "wholesaler" }
];

// Counties options mapped from API response

const CallRecordsDialog: React.FC<AddCallDialogProps> = ({
  visible,
  setVisible,
  accountId,
  propertyId,
  checkoutId,
  item,
  isEdit = false
}) => {
  const { data } = useCounties();
  const countyOptions = useMemo(
    () =>
      Array.isArray(data)
        ? data
            .filter(
              (c: any) =>
                c && typeof c.name === "string" && c.name.trim().length > 0
            )
            .map((c: any) => ({ label: c.name, value: c.name }))
        : [],
    [data]
  );
  const [callingStatus, setCallingStatus] = useState<any>(
    isEdit ? item?.calloutcome : null
  );
  const [doNotDisturb, setDoNotDisturb] = useState(
    isEdit ? item?.enablednd : false
  );
  const [callNote, setCallNote] = useState(isEdit ? item?.callnotes : "");
  const [scheduleDate, setScheduleDate] = useState(
    isEdit ? moment(item?.followupdate).toDate() : null
  );
  const [city, setCity] = useState<any[]>(
    isEdit
      ? Array.isArray(item?.cityofinterest)
        ? item?.cityofinterest
        : typeof item?.cityofinterest === "string"
        ? item?.cityofinterest
            .split(",")
            .map((c: string) => c.trim())
            .filter((c: string) => c.length > 0)
        : item?.cityofinterest
        ? [item?.cityofinterest]
        : []
      : []
  );
  const calendarRef2 = useRef<any>(null);
  const { showSuccess, showInfo }: any = useToast();

  const resetForm = () => {
    setCallingStatus(null);
    setDoNotDisturb(false);
    setCallNote("");
    setScheduleDate(null);
    setCity([]);
  };

  const isNotesRequired = notesRequiredStatuses.has(
    (callingStatus || "").toString().toLowerCase()
  );

  useEffect(() => {
    if (visible && isEdit && item) {
      setCallingStatus(item?.calloutcome ?? null);
      setDoNotDisturb(item?.enablednd ?? false);
      setCallNote(item?.callnotes ?? "");
      setScheduleDate(
        item?.followupdate ? moment(item?.followupdate).toDate() : null
      );
      setCity(
        Array.isArray(item?.cityofinterest)
          ? item?.cityofinterest
          : typeof item?.cityofinterest === "string"
          ? item?.cityofinterest
              .split(",")
              .map((c: string) => c.trim())
              .filter((c: string) => c.length > 0)
          : item?.cityofinterest
          ? [item?.cityofinterest]
          : []
      );
    }
  }, [visible, isEdit, item]);

  const addNotesMutation = useAddNotes(
    (data) => {
      showSuccess("success", "Call Record added Successfully.");
      setVisible(false);
      setCallingStatus(null);
      setDoNotDisturb(false);
      setCallNote(null);
      setScheduleDate(null);
      setCity([]);
    },
    (error) => {
      console.log("error", error);
    }
  );

  const addCallRecordsMutation = useAddCallRecords(
    (data) => {
      if (city?.length > 0) {
        addNotesMutation.mutate({
          accountId: accountId,
          pubPropertyId: propertyId,
          notes: `City of Interest:- ${city.join(", ")}`,
          isPrivate: false
        });
      } else {
        showSuccess("success", "Call Record added Successfully.");
        setVisible(false);
        setCallingStatus(null);
        setDoNotDisturb(false);
        setCallNote(null);
        setScheduleDate(null);
        setCity([]);
      }
    },
    (error) => {
      showSuccess("success", "Failed to add Call Record.");
      console.log("error", error);
    }
  );

  const editCallRecordsMutation = useEditCallRecords(
    (data) => {
      showSuccess("success", "Call Record updated Successfully.");
      setCallingStatus(null);
      setDoNotDisturb(false);
      setCallNote(null);
      setScheduleDate(null);
      setCity([]);
      setVisible(false);
    },
    (error) => {
      showSuccess("success", "Failed to update Call Record.");
      console.log("error", error);
    }
  );

  return (
    <Dialog
      visible={visible}
      closable={true}
      closeOnEscape={true}
      header={<span className={styles.header}>Call Record</span>}
      dismissableMask={true}
      blockScroll={true}
      onHide={() => {
        resetForm();
        setVisible(false);
      }}
      className={styles.dialog}
      maskClassName={styles.dialogMask}
      draggable={false}
      resizable={false}
    >
      <label className={styles.label}>Call OutCome *</label>
      <DropdownC
        value={callingStatus}
        showClear={true}
        onChange={(e: any) => setCallingStatus(e.value)}
        options={callingStatusOptions}
        optionLabel="label"
        placeholder="Select status"
        panelClassName={styles.dropdownList}
        className={styles.dropdownBox}
      />
      <label className={styles.label}>Call Notes</label>
      <label className={styles.label}>{isNotesRequired ? " *" : ""}</label>
      <textarea
        name="add-notes"
        id="notes"
        className={styles.textarea}
        placeholder={"Call Notes..."}
        value={callNote}
        onChange={(e) => setCallNote(e.target.value)}
        maxLength={350}
        rows={3}
      />
      <label className={styles.label}>City Of Interest</label>
      <MultiSelectC
        value={city}
        showClear={true}
        onChange={(e: any) => setCity(e.value)}
        options={countyOptions}
        optionLabel="label"
        placeholder="Select Cities Of Interest"
        panelClassName={styles.dropdownList}
        className={styles.dropdownBox}
        maxSelectedLabels={4}
        showTooltip={true}
        filter
      />

      <label className={styles.label}>Schedule Follow-Up</label>
      <div
        className={styles.ScheduleDate}
        onClick={() => calendarRef2.current?.show()}
      >
        <img src="/images/cal-history.svg" alt="" className={styles.img} />
        <Calendar
          value={scheduleDate}
          ref={calendarRef2}
          onChange={(e: any) => setScheduleDate(e.value)}
          panelClassName={styles.calendarPanel}
          readOnlyInput
          placeholder="Select Date"
        />
        <img
          src="/images/RightArrow.svg"
          alt=""
          className={styles.rightArrow}
        />
      </div>
      {/* <div className={styles.switchRow}>
        <label className={styles.label}>Set Do Not Disturb</label>
        <InputSwitch
          checked={doNotDisturb}
          className={styles.inputSwitch}
          onChange={(e: any) => setDoNotDisturb(e.value)}
        />
      </div> */}
      <div className={styles.btnWrap}>
        <Buttonc
          btnType="border"
          type="submit"
          tabIndex={7}
          btnWrapClassName={styles.btnWrapClass}
          className={styles.cancelBtn}
          label={"Cancel"}
          disabled={
            addCallRecordsMutation.isPending ||
            editCallRecordsMutation.isPending ||
            addNotesMutation.isPending
          }
          onClick={() => {
            resetForm();
            setVisible(false);
          }}
        />
        <Buttonc
          type="submit"
          btnWrapClassName={styles.btnWrapClass}
          tabIndex={7}
          label={"Save Call Record"}
          loading={
            addCallRecordsMutation.isPending ||
            editCallRecordsMutation.isPending ||
            addNotesMutation.isPending
          }
          className={styles.subBtn}
          onClick={() => {
            if (callingStatus === null || callingStatus?.length === 0) {
              showInfo("info", "Please select call outcome.");
            } else {
              const statusLower = (callingStatus || "")
                .toString()
                .toLowerCase();
              if (
                notesRequiredStatuses.has(statusLower) &&
                (!callNote || callNote?.trim().length === 0)
              ) {
                showInfo("info", "Please enter call notes.");
                return;
              }
              if (item?.id) {
                editCallRecordsMutation.mutate({
                  id: item?.id,
                  accountId: accountId,
                  pubPropertyId: propertyId,
                  checkoutId: checkoutId,
                  callOutcome: callingStatus,
                  callNotes: callNote?.trim(),
                  cityOfInterest: city.length > 0 ? city.join(", ") : "",
                  followupDate: scheduleDate || null,
                  enableDnd: doNotDisturb,
                  dndAt: doNotDisturb ? new Date() : null
                });
              } else {
                addCallRecordsMutation.mutate({
                  accountId: accountId,
                  pubPropertyId: propertyId,
                  checkoutId: checkoutId,
                  callOutcome: callingStatus,
                  callNotes: callNote?.trim(),
                  cityOfInterest: city.length > 0 ? city.join(", ") : "",
                  followupDate: scheduleDate,
                  enableDnd: doNotDisturb,
                  dndAt: doNotDisturb ? new Date() : null
                });
              }
            }
          }}
        />
      </div>
    </Dialog>
  );
};

export default CallRecordsDialog;
